<template>
  <v-flex>
    <Subheader title="Aquarius servers Status" no-search></Subheader>
    <v-card>
      <v-list two-line subheader>
        <v-list-tile>
          <v-list-tile-avatar>
            <v-icon class="icon_border" :color="status_icons[NgStatus].theme">{{ status_icons[NgStatus].icon }}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Aquarius NG</v-list-tile-title>
            <v-list-tile-sub-title>{{ NgStatus }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-flex>
</template>

<script>
import Subheader from '@/components/generic/Subheader'
import { createNamespacedHelpers } from 'vuex'
const logging =  createNamespacedHelpers('logging')


export default {
  components: {
    Subheader,
  },
  data() {
    return {
      status_icons: {
        'Stable' : {
          icon: 'looks',
          theme: 'success',
        },
        'Instable' : {
          icon: 'warning',
          theme: 'error',
        },
        'Unknown' : {
          icon: 'sync_problem',
          theme: 'warning',
        },
      },
    }
  },
  mounted() {
    this.getServerStatus()
  },
  computed: {    
    ...logging.mapGetters(['ServerStatus']),
    NgStatus() {
      if(this.ServerStatus){
        var matched = this.ServerStatus.find(x => x.ServerName == 'AquariusNG')
        if(matched) {
          return matched.ServerStatus
        }
      }
      return 'Unknown'
    },
  },
  methods: {
    ...logging.mapActions(['getServerStatus']),
  },
}
</script>

<style lang="stylus" scoped>
.icon_border {
  border: 1px solid rgba(0,0,0,0.54) !important;
}
</style>
